import React from 'react';

import { InstallationGuideProvider } from '../components/installation-guide/InstallationGuideProvider';
import { InstallationGuideWizard } from '../components/installation-guide/InstallationGuideWizard';

/**
 * InstallationGuidePage - Main page component for the installation guide wizard
 *
 * Uses the existing InstallationGuideProvider/Wizard for both OS v2 and standard flows.
 * Device info is read from localStorage (stored by LookupPage in both flows).
 *
 * This ensures:
 * - Same guide UI for all users
 * - Model-specific instructions when available
 * - Consistent step-by-step wizard experience
 */
const InstallationGuidePage: React.FC = () => {
  return (
    <InstallationGuideProvider>
      <InstallationGuideWizard />
    </InstallationGuideProvider>
  );
};

export default InstallationGuidePage;
